import styled from 'styled-components';

export const AuthorsPageContainer = styled.div`
	width: 100%;
	padding: 2.5rem 1rem;

	.breadcrumbs {
		margin-bottom: 2rem;
	}

	.header {
		margin-bottom: 2rem;
	}

	.container {
		max-width: 1084px;
		width: 100%;
		margin: 0 auto;
	}

	.title {
		margin-bottom: 0.25rem;
	}

	.meta-text {
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}

	.author {
		display: grid;
		grid-template-rows: auto 1fr auto;
		flex: 0 1 calc(33.33%);
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.25rem;
		padding: 2rem 1rem;
		text-align: center;
		cursor: pointer;

		&-title {
			margin-bottom: 0.25rem;
		}

		&-position {
			margin-bottom: 0.25rem;
			color: ${({ theme }) => theme.v3.colors.dark[0]};
		}

		&-posts {
			color: ${({ theme }) => theme.v3.colors.dark[0]};
		}
	}
`;
